export default __webpack_public_path__ + "assets/images/3319edf259df1e7014be6d4949fc86b1.png";